// extracted by mini-css-extract-plugin
export default {"addToCartControl":"y1-z","giftCard":"z1-z","btnContainer":"A1-z","cartButton":"B1-z","disabled":"C1-z"};